// extracted by mini-css-extract-plugin
export var cardContainerBody = "CardBodyContainer-module--cardContainerBody--e9ce3";
export var checklist = "CardBodyContainer-module--checklist--43f6b";